/**
 * Client Service Factory
 * Based on auth-system.md specification
 * 
 * Provides singleton access to all client-side services.
 * Services are lazily instantiated on first access.
 */

import { AuthClientService } from "./auth/auth-client.service";

/**
 * Client-side service factory
 * Creates and caches service instances
 */
class ClientServiceFactory {
  private _auth: AuthClientService | null = null;

  /**
   * Get the auth service instance
   */
  get auth(): AuthClientService {
    if (!this._auth) {
      this._auth = new AuthClientService();
    }
    return this._auth;
  }

  /**
   * Alias for backwards compatibility
   */
  get authClient(): AuthClientService {
    return this.auth;
  }

  /**
   * Reset all services (useful for testing)
   */
  reset(): void {
    this._auth = null;
  }
}

// Singleton instance
export const services = new ClientServiceFactory();

// Export for direct access if needed
export { AuthClientService };
